import React from 'react';
import { marketIntelHubContent } from '../rich-content/market-intel-hub-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const MarketIntelHubDetailPage = () => {
  return <AutomaticPageBuilder content={marketIntelHubContent} />;
};

export default MarketIntelHubDetailPage;
